import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { Rocket, Globe, Zap, Shield, Terminal, Share2 } from 'lucide-react';

export default function ProductKinetics() {
  return (
    <SubpageTemplate 
      title="Kinetics Distribution"
      subtitle="Real-time deployment"
      description="Ship with confidence. Kinetics handles the global edge distribution, automated social assets, and webhook relays to power your GTM from day zero."
      icon={Rocket}
      features={[
        {
          title: "Edge Delivery",
          description: "One-click deployment to a global CDN with zero configuration and sub-second cold starts.",
          icon: Globe
        },
        {
          title: "Social Synthesis",
          description: "Automatically generates Product Hunt submissions, X threads, and LinkedIn announcements from build metadata.",
          icon: Share2
        },
        {
          title: "Webhook Relay",
          description: "Connect your deployments to thousands of tools via Zapier, Make, or custom REST hooks.",
          icon: Terminal
        }
      ]}
    />
  );
}
